import { isLocalStorageSupported } from "@outschool/local-storage";

const CATEGORY_PAGE_VISIT_HISTORY = "categoryPageVisitHistory";
const MAX_SIZE = 200;

const localStorage = isLocalStorageSupported();

export interface CategoryPageVisit {
  categorySlug: string;
  createdAt: Date;
}

export function pushToTop(categorySlug: string) {
  if (!categorySlug) {
    return;
  }
  const list = getListFromStore() || [];
  const newList = list
    .filter(item => !!item.categorySlug)
    .filter(item => item.categorySlug !== categorySlug)
    .slice(0, MAX_SIZE);
  newList.unshift({ categorySlug, createdAt: new Date() });
  saveListToStore(newList);
}

export function getList() {
  return getListFromStore() || [];
}

export function clear() {
  if (!localStorage) {
    return;
  }
  localStorage.removeItem(CATEGORY_PAGE_VISIT_HISTORY);
}

function getListFromStore() {
  if (!localStorage) {
    return [];
  }
  try {
    const jsonStr = localStorage.getItem(CATEGORY_PAGE_VISIT_HISTORY);
    const { list } = jsonStr ? JSON.parse(jsonStr) : { list: [] };
    return list as CategoryPageVisit[];
  } catch (e) {
    console.log(e);
    return null;
  }
}

function saveListToStore(list: CategoryPageVisit[]) {
  if (!localStorage) {
    return;
  }
  try {
    const jsonStr = JSON.stringify({ list });
    localStorage.setItem(CATEGORY_PAGE_VISIT_HISTORY, jsonStr);
  } catch (e) {
    console.log(e);
  }
}
